import { render } from "./MyContactorView.vue?vue&type=template&id=d20946d2&scoped=true"
import script from "./MyContactorView.vue?vue&type=script&lang=js"
export * from "./MyContactorView.vue?vue&type=script&lang=js"

import "./MyContactorView.vue?vue&type=style&index=0&id=d20946d2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20946d2"]])

export default __exports__